export default "__VITE_ASSET__Bm_hzB7c__"